import React, { useState } from 'react'
 
 
import AccountDetailList from './AccountDetailList';
import AccountDetailForm from './AccountDetailForm';

const AccountDetail= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <AccountDetailForm addForm={setFromIsShown} update={upData} />
        ) : (
          <AccountDetailList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default AccountDetail